<template lang="pug">
	.easy-creative--question--hierarchical
		DxDropDownBox(
			:value.sync="treeBoxValue"
			:opened.sync="isTreeBoxOpened"
			:show-clear-button="true"
			:data-source="dataSource"
			value-expr="Oid"
			display-expr="__displayValue"
			:placeholder="question.Placeholder"
			stylingMode="filled"
			@value-changed="syncTreeViewSelection($event)"
		)
			DxTreeView.compact(
				ref="tree"
				:data-source="dataSource"
				:select-by-click="true"
				data-structure="plain"
				key-expr="Oid"
				parent-id-expr="ParentOid"
				selection-mode="single"
				display-expr="Name"
				:searchEnabled="true"
				@content-ready="$event.component.selectItem(treeBoxValue)"
				@item-selection-changed="treeViewItemSelectionChanged($event)"
				@item-click="onTreeItemClick($event)"
			)
</template>

<script>
	import _ from 'lodash';
	import Loader from 'app-core/Loader.vue';
	import DxButton from 'devextreme-vue/button';
	import DxDropDownBox from 'devextreme-vue/drop-down-box';
	import DxTreeView from 'devextreme-vue/tree-view';
	import DataSource from 'devextreme/data/data_source';

	export default {
		translationCategory: 'creative.EasyCreative',
		name: 'easy-creative-question--hierarchical',
		props: ['info', 'question', 'questionTypes', 'error'],
		components: {
			Loader, DxButton, DxDropDownBox, DxTreeView
		},
		watch: {
			treeBoxValue() {
				this.setAnswer();
			}
		},
		data() {
			return {
				isTreeBoxOpened: false,
				treeBoxValue: null,
				dataSource: null
			};
		},
		computed: {
			rawItems() {
				const result = [];
				const process = (arr, parent) => {
					if (!arr?.length) return;
					arr.map(f => {
						if (parent) {
							f.ParentOid = parent.Oid;
							f.__displayValue = `${parent.__displayValue || parent.Name}\\${f.Name}`;
							f.__parentItems = [...parent.__parentItems, parent.Oid];
						} else {
							f.__displayValue = f.Name;
							f.__parentItems = [];
						}
						result.push(f);
						process(f.SubItems, f);
					});
				}
				process(this.question.BriefPickListItems);
				return result;
			},
			selectedId() {
				return _.last(this.treeBoxValue || []);
			},
			selectedItem() {
				return this.rawItems.find(f => f.Oid === this.selectedId);
			},
			displayValue() {
				return this.selectedItem?.__displayValue;
			}
		},
		mounted() {
			if (__DEBUG__)
				window.easyCreativeQuestionHierarchical = this;
			this.createDataSource();
			this.restoreValue();
		},
		methods: {
			restoreValue() {
				if (!this.question.__value) return;

				this.treeBoxValue = [this.question.__value];
				this.syncTreeViewSelection();
			},
			setAnswer() {
				this.$set(this.question, 'PickListAnswerId', this.selectedId);
				this.$set(this.question, 'PickListParentAnswerIds', this.selectedItem?.__parentItems);
				this.$set(this.question, 'BriefPickListDisplayValue', this.displayValue);
			},
			onTreeItemClick() {
				this.isTreeBoxOpened = false;
			},
			treeViewItemSelectionChanged(e) {
				if (__DEBUG__)
					console.debug('treeViewItemSelectionChanged', { e });
				this.treeBoxValue = e.component.getSelectedNodeKeys();
				this.isTreeBoxOpened = false;
			},
			syncTreeViewSelection(e) {
				if (__DEBUG__)
					console.debug('syncTreeViewSelection', { e });
				if (!this.treeBoxValue) {
					this.$refs.tree.instance.unselectAll();
				} else {
					this.$refs.tree.instance.selectItem(this.treeBoxValue);
				}
			},
			createDataSource() {
				this.dataSource = new DataSource({
					paginate: false,
					load: () => {
						return Promise.resolve(this.rawItems);
					},
					byKey: (key) => {
						return Promise.resolve(this.rawItems.find(f => f.Oid === key));
					},
					key: 'Oid'
				})
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.easy-creative--question--hierarchical {
		
	}
</style>
